
    <template>
      <section class="content element-doc">
        <h2 id="ai-dui-hua"><a class="header-anchor" href="#ai-dui-hua">¶</a> AI 对话</h2>
<div class="tip">
<p>示例需要第三方依赖包 <code>dompurify</code> <code>markdown-it </code></p>
</div>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;sh-ai-chat&quot;&gt;
    &lt;el-row :gutter=&quot;16&quot;&gt;
      &lt;el-col :span=&quot;4&quot;&gt;
        &lt;ShAiHistoryChat
          chatTitleKey=&quot;title&quot;
          :historyChat=&quot;historyChat&quot;
          :activeChatId.sync=&quot;chatId&quot;
          @select-chat=&quot;selectChat&quot;
          @delete-chat=&quot;onDeleteChat&quot;
          @new-chat=&quot;onAddChat&quot;
        &gt;
        &lt;/ShAiHistoryChat&gt;
      &lt;/el-col&gt;
      &lt;el-col :span=&quot;20&quot;&gt;
        &lt;ShAiChatMain
          :aiModelList=&quot;modelList&quot;
          :activeModelId.sync=&quot;activeModelId&quot;
          :aiMessageList=&quot;messageList&quot;
          :aiMessageOptions=&quot;messageOptions&quot;
          :loading=&quot;loading&quot;
          :aiChatTitle=&quot;chatTitle&quot;
          @send=&quot;onSendMessage&quot;
          @refresh=&quot;onMessageRefresh&quot;
          ref=&quot;aiChatMain&quot;
        /&gt;
      &lt;/el-col&gt;
    &lt;/el-row&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  const AIMessageJson = require('../json/ai-message.json')
  const AIHistoryList = require('../json/ai-history-list.json')
  const DOMPurify = require('dompurify')
  const md = require('markdown-it')
  export default {
    data() {
      return {
        drawer: true,
        historyChat: AIHistoryList,
        chatId: 1,
        modelList: [
          {
            id: 1,
            name: '模型1'
          },
          {
            id: 2,
            name: '模型2'
          }
        ],
        activeModelId: 1,
        messageList: [
          {
            id: 1,
            content: '你好',
            role: 'user'
          },
          {
            id: 2,
            content: md().render(DOMPurify.sanitize(AIMessageJson.content)),
            role: 'assistant'
          }
        ],
        messageOptions: {
          contentKey: 'content',
          userKey: 'user',
          aiKey: 'assistant',
          roleKey: 'role'
        },
        loading: false,
        chatTitle: 'AI对话1111'
      }
    },
    methods: {
      handleClose() {
        this.drawer = false
      },
      // 新建AI对话
      onAddChat() {
        this.chatId = null
        this.messageList = []
        this.$refs.aiChatMain.onInputFocus()
      },
      getHistoryChat() {
        // 模拟获取历史聊天记录
        return this.historyChat
      },
      selectChat(item) {
        this.chatId = item.id
        this.chatTitle = item.title
        // this.
      },
      onDeleteChat(e) {
        console.log('删除历史聊天:', e)
      },
      onChangeModel(e) {
        this.activeModelId = e
      },
      async onSendMessage(e) {
        this.loading = true

        this.messageList.push({
          id: this.messageList.length + 1,
          content: e,
          role: 'user'
        })

        let assistantMsg = {
          id: this.messageList.length + 1,
          content: '',
          role: 'assistant'
        }
        this.messageList.push(assistantMsg)
        this.loading = false
        // 模拟AI回复
        const chars = AIMessageJson.message.split('')
        let index = 0
        assistantMsg = this.messageList[this.messageList.length - 1]
        let rawContent = ''
        const timer = setInterval(() =&gt; {
          if (index &lt; chars.length) {
            rawContent += chars[index]
            assistantMsg.content = md().render(DOMPurify.sanitize(rawContent))
            this.$refs.aiChatMain.scrollToBottom()
            index++
          } else {
            clearInterval(timer)
          }
        }, 20)

        // 新增对话时模拟延迟返回真实 chatId
        setTimeout(() =&gt; {
          if (!this.chatId) {
            const realId = Math.floor(Math.random() * 10000)
            this.historyChat.push({
              id: realId,
              title: `AI对话${realId}`,
              createTime: '2025-06-24 12:00:00'
            })
            this.chatId = realId
          }
        }, 1000)
      },
      onMessageRefresh(e) {
        console.log('重新生成:', e)
      }
    }
  }
&lt;/script&gt;

&lt;style lang=&quot;scss&quot;&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="aihistorychat-attributes"><a class="header-anchor" href="#aihistorychat-attributes">¶</a> AIHistoryChat Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>history-chat</td>
<td>历史对话记录</td>
<td>Array</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>active-chat-id</td>
<td>当前选中的历史对话记录 id,支持.sync</td>
<td>Number</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>chat-title-key</td>
<td>历史聊天记录标题字段名</td>
<td>String</td>
<td>-</td>
<td>name</td>
</tr>
</tbody>
</table>
<h3 id="aihistorychat-events"><a class="header-anchor" href="#aihistorychat-events">¶</a> AIHistoryChat Events</h3>
<table>
<thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>select-chat</td>
<td>选择历史对话</td>
<td>目前选中的值</td>
</tr>
<tr>
<td>delete-chat</td>
<td>删除历史对话</td>
<td>目前删除的值</td>
</tr>
<tr>
<td>new-chat</td>
<td>新建对话</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="aihistorychat-slots"><a class="header-anchor" href="#aihistorychat-slots">¶</a> AIHistoryChat Slots</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>default</td>
<td>默认插槽 ,参数为{chatData,index}</td>
</tr>
</tbody>
</table>
<h3 id="aichatmain-attributes"><a class="header-anchor" href="#aichatmain-attributes">¶</a> AIChatMain Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>ai-chat-title</td>
<td>聊天标题</td>
<td>String</td>
<td>-</td>
</tr>
<tr>
<td>ai-model-list</td>
<td>AI 模型列表</td>
<td>Array</td>
<td>-</td>
</tr>
<tr>
<td>active-model-id</td>
<td>当前激活的 AI 模型 id，支持.sync</td>
<td>Number</td>
<td>-</td>
</tr>
<tr>
<td>ai-model-options</td>
<td>AI 模型选项配置</td>
<td>Object</td>
<td>{labelKey: 'name', valueKey: 'id'}</td>
</tr>
<tr>
<td>ai-message-list</td>
<td>消息列表</td>
<td>Array</td>
<td>-</td>
</tr>
<tr>
<td>ai-message-options</td>
<td>消息选项配置, contentKey:消息内容 key, userKey: 用户角色, aiKey: AI 角色 , roleKey:角色字段 key</td>
<td>Object</td>
<td>{contentKey: 'content', userKey: 'user', aiKey: 'assistant', roleKey: 'role'}</td>
</tr>
<tr>
<td>loading</td>
<td>是否加载中</td>
<td>Boolean</td>
<td>false</td>
</tr>
<tr>
<td>width</td>
<td>聊天框宽度</td>
<td>String</td>
<td>80%</td>
</tr>
</tbody>
</table>
<h3 id="aichatmain-events"><a class="header-anchor" href="#aichatmain-events">¶</a> AIChatMain Events</h3>
<table>
<thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change-model</td>
<td>切换 AI 模型</td>
<td>目前切换的值</td>
</tr>
<tr>
<td>send</td>
<td>发送消息</td>
<td>目前发送的值</td>
</tr>
<tr>
<td>refresh</td>
<td>重新生成消息</td>
<td>选中的值</td>
</tr>
</tbody>
</table>
<h3 id="aichatmain-methods"><a class="header-anchor" href="#aichatmain-methods">¶</a> AIChatMain Methods</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>scrollToBottom</td>
<td>流式响应时可自动滚动到底部</td>
</tr>
<tr>
<td>focus</td>
<td>输入框获取焦点事件</td>
</tr>
</tbody>
</table>
<h3 id="aichatmain-slots"><a class="header-anchor" href="#aichatmain-slots">¶</a> AIChatMain Slots</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>header</td>
<td>头部插槽</td>
</tr>
<tr>
<td>default</td>
<td>默认插槽 ,参数为{chatData,index}</td>
</tr>
<tr>
<td>footer</td>
<td>底部插槽</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"sh-ai-chat"},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":4}},[_c('ShAiHistoryChat',{attrs:{"chatTitleKey":"title","historyChat":_vm.historyChat,"activeChatId":_vm.chatId},on:{"update:activeChatId":function($event){_vm.chatId=$event},"update:active-chat-id":function($event){_vm.chatId=$event},"select-chat":_vm.selectChat,"delete-chat":_vm.onDeleteChat,"new-chat":_vm.onAddChat}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":20}},[_c('ShAiChatMain',{ref:"aiChatMain",attrs:{"aiModelList":_vm.modelList,"activeModelId":_vm.activeModelId,"aiMessageList":_vm.messageList,"aiMessageOptions":_vm.messageOptions,"loading":_vm.loading,"aiChatTitle":_vm.chatTitle},on:{"update:activeModelId":function($event){_vm.activeModelId=$event},"update:active-model-id":function($event){_vm.activeModelId=$event},"send":_vm.onSendMessage,"refresh":_vm.onMessageRefresh}})],1)],1)],1)]],2)}
var staticRenderFns = []

  
    const AIMessageJson = require('../json/ai-message.json')
  const AIHistoryList = require('../json/ai-history-list.json')
  const DOMPurify = require('dompurify')
  const md = require('markdown-it')
  const democomponentExport = {
    data() {
      return {
        drawer: true,
        historyChat: AIHistoryList,
        chatId: 1,
        modelList: [
          {
            id: 1,
            name: '模型1'
          },
          {
            id: 2,
            name: '模型2'
          }
        ],
        activeModelId: 1,
        messageList: [
          {
            id: 1,
            content: '你好',
            role: 'user'
          },
          {
            id: 2,
            content: md().render(DOMPurify.sanitize(AIMessageJson.content)),
            role: 'assistant'
          }
        ],
        messageOptions: {
          contentKey: 'content',
          userKey: 'user',
          aiKey: 'assistant',
          roleKey: 'role'
        },
        loading: false,
        chatTitle: 'AI对话1111'
      }
    },
    methods: {
      handleClose() {
        this.drawer = false
      },
      // 新建AI对话
      onAddChat() {
        this.chatId = null
        this.messageList = []
        this.$refs.aiChatMain.onInputFocus()
      },
      getHistoryChat() {
        // 模拟获取历史聊天记录
        return this.historyChat
      },
      selectChat(item) {
        this.chatId = item.id
        this.chatTitle = item.title
        // this.
      },
      onDeleteChat(e) {
        console.log('删除历史聊天:', e)
      },
      onChangeModel(e) {
        this.activeModelId = e
      },
      async onSendMessage(e) {
        this.loading = true

        this.messageList.push({
          id: this.messageList.length + 1,
          content: e,
          role: 'user'
        })

        let assistantMsg = {
          id: this.messageList.length + 1,
          content: '',
          role: 'assistant'
        }
        this.messageList.push(assistantMsg)
        this.loading = false
        // 模拟AI回复
        const chars = AIMessageJson.message.split('')
        let index = 0
        assistantMsg = this.messageList[this.messageList.length - 1]
        let rawContent = ''
        const timer = setInterval(() => {
          if (index < chars.length) {
            rawContent += chars[index]
            assistantMsg.content = md().render(DOMPurify.sanitize(rawContent))
            this.$refs.aiChatMain.scrollToBottom()
            index++
          } else {
            clearInterval(timer)
          }
        }, 20)

        // 新增对话时模拟延迟返回真实 chatId
        setTimeout(() => {
          if (!this.chatId) {
            const realId = Math.floor(Math.random() * 10000)
            this.historyChat.push({
              id: realId,
              title: `AI对话${realId}`,
              createTime: '2025-06-24 12:00:00'
            })
            this.chatId = realId
          }
        }, 1000)
      },
      onMessageRefresh(e) {
        console.log('重新生成:', e)
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  